import React from 'react';
import { Spinner } from '@scale/scaleui';

interface LoadingProps {
  loading: boolean;
  children: React.ReactNode;
}

export const LinterLoading: React.FC<LoadingProps> = ({ loading, children }) => {
  if (loading) {
    return <Spinner size="lg" />;
  }

  return <>{children}</>;
};
